module.exports = __webpack_public_path__ + "static/media/fullstack.9376c4a5.svg";